import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FacilityService } from 'app/shared/services/facility.service'; // importa il service

export interface ActivityCheckDialogData {
  facility: any;
  activityData?: any;
  referralGroups?: any[];
  activityPeriods?: any;
}

@Component({
    selector: 'app-activity-check-dialog',
    templateUrl: './activity-check-dialog.component.html',
    styleUrls: ['./activity-check-dialog.component.scss'],
    standalone: false
})
export class ActivityCheckDialogComponent {
  public baseUrl = window.location.origin;
  customDate: string = '';
  customDateFrom: string = '';
  customDateTo: string = '';
  customPeriod: { Received?: number; Sent?: number } = {};

  constructor(
    public dialogRef: MatDialogRef<ActivityCheckDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActivityCheckDialogData,
    private facilityService: FacilityService
  ) {}

  get selectedFacility() {
    return this.data.facility;
  }

  get activityData() {
    return this.data.activityData;
  }

  get activityPeriods() {
    return this.data.activityPeriods || {};
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-AU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatInstallDate(dateString: string | null): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-AU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  getInstallDaysAgo(facility: any): string {
    if (!facility.InstallDate) return '';
    
    const installDate = new Date(facility.InstallDate);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - installDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return `${diffDays} days ago`;
  }

  getGroupColor(referralGroupId: string | number): string {
    const colors: { [key: string]: string } = {
      '1': '#4CAF50',
      '2': '#2196F3',
      '3': '#FF9800',
      '4': '#9C27B0',
      '5': '#F44336'
    };

    const groupId = referralGroupId?.toString() || '';
    return colors[groupId] || '#757575';
  }

  getReferralGroupName(referralGroupId: string | number): string {
    const groupId = referralGroupId?.toString() || '';
    
    if (this.data.referralGroups) {
      const group = this.data.referralGroups.find(g => g.value?.toString() === groupId);
      return group?.label || 'Unknown Group';
    }
    
    const defaultGroups: { [key: string]: string } = {
      '1': 'I-MED',
      '2': 'Capitol Health',
      '3': 'Healius',
      '4': 'Sonic Healthcare',
      '5': 'Other Group'
    };

    return defaultGroups[groupId] || 'Unknown Group';
  }

  getStatusColor(status: string | undefined): string {
    const colors: { [key: string]: string } = {
      'active': '#4CAF50',
      'inactive': '#F44336',
      'pending': '#FF9800',
      'red': '#F44336',
      'green': '#4CAF50',
      'yellow': '#FF9800',
      'unknown': '#757575'
    };
    return colors[status?.toLowerCase() || 'unknown'] || colors['unknown'];
  }

  getStatusIcon(status: string | undefined): string {
    const icons: { [key: string]: string } = {
      'active': 'check_circle',
      'inactive': 'error',
      'pending': 'schedule',
      'red': 'error',
      'green': 'check_circle',
      'yellow': 'warning',
      'unknown': 'help'
    };
    return icons[status?.toLowerCase() || 'unknown'] || icons['unknown'];
  }

  getDayDifferenceText(dayDifference: number | undefined): string {
    if (dayDifference === undefined || dayDifference === null) return 'N/A';
    
    if (dayDifference === 0) return 'Today';
    if (dayDifference === 1) return '1 day ago';
    return `${dayDifference} days ago`;
  }

  onCustomDateRangeChange() {
    if (!this.customDateFrom || !this.customDateTo || !this.selectedFacility?.FacilityID) {
      this.customPeriod = {};
      return;
    }
    this.facilityService.getReport({
      facility_id: this.selectedFacility.FacilityID,
      date_from: this.customDateFrom,
      date_to: this.customDateTo
    }).subscribe({
      next: (response) => {
        this.customPeriod = response?.Custom || { Received: 0, Sent: 0 };
      },
      error: () => {
        this.customPeriod = { Received: 0, Sent: 0 };
      }
    });
  }
}